import { FormLabel, Typography } from "@mui/material";

const CustomLabel = ({ label, required }) => {
  return (
    <FormLabel>
      <Typography
        sx={{
          position: "relative",
          lineHeight: 1.154,
          fontWeight: 400,
          fontSize: "13px",
          color: "text.primary",
          mb: "4px",
        }}
      >
        {label}<span style={{ color: '#EA5455', fontSize: '14px' }}>{required ? ' *' : ''}</span>
      </Typography>
    </FormLabel>
  );
};

export default CustomLabel;
